import { http_config } from '../config.js'
import axios from 'axios'
import qs from 'qs'
import { Toast } from 'vant';
const tips = {
    1: '抱歉,出现了一个错误',
    1000001: '访问Toekn错误',
    1000002: '用户Toekn不能为空',
    1000003: '接口路径错误',
    1000004: '数据签名错误',
    1000005: '用户Toekn解析错误'
}

class HTTP {
    constructor() {
        //axios配置
        axios.defaults.timeout = 5000;
        axios.defaults.baseURL = http_config.api_base_url;
        // http request 拦截器
        axios.interceptors.request.use(
            config => {
                if (http_config.access_token) {
                    config.headers['AccessToken'] = http_config.access_token
                }
                return config
            },
            err => {
                return Promise.reject(err)
            },
        )
    }
    request({ url, data = {}, method = 'GET' }) {
        return new Promise((resolve, reject) => {
            this._request(url, resolve, reject, data, method)
        })
    }
    _request(url, resolve, reject, data = {}, method = 'GET') {
        let config = {
            url: url,
            method: method,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        }
        method == 'GET' ? config['params'] = data : config['data'] = qs.stringify(data)
        axios(config).then(res => {
            const code = res.status.toString()
            if (code.startsWith('2')) {
                resolve(res.data)
            } else {
                reject()
                const error_code = res.data.code
                this._show_error(error_code)
            }
        }).catch(err => {
            reject()
            this._show_error(1)
        })
    }
    _show_error(error_code) {
        if (!error_code) {
            error_code = 1
        }
        const tip = tips[error_code]
        Toast.fail({
            duration: 2000,
            message: tip ? tip : tips[1]
        });
    }
}

export { HTTP }
